// extracted by mini-css-extract-plugin
export default {"folder_item_container":"folder-item_folder_item_container__y1CsH","folder_content_container":"folder-item_folder_content_container__Mjtu6","active":"folder-item_active__olERR"};